import {
    FETCH_PERMISSIONS_SUCCESS,
    FETCH_PERMISSIONS_FAILURE,
  } from "./actionTypes";
  
  const initialState = {
    permissions: {},
    error: null,
  };
  
  const permissions = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_PERMISSIONS_SUCCESS:
        return {
          ...state,
          permissions: action.payload,
          error: null,
        };
      case FETCH_PERMISSIONS_FAILURE:
        return {
          ...state,
          permissions: {},
          error: action.payload,
        };
      default:
        return state;
    }
  };
  
  export default permissions;